export const LIST_SURVEYS = 'LIST_SURVEYS';
export const LIST_SURVEYS_SUCCESS = 'LIST_SURVEYS_SUCCESS';
export const LIST_SURVEYS_FAILED = 'LIST_SURVEYS_FAILED';
